import React from 'react';
import './Sponsors.css';

const Sponsors = () => {
  const sponsorFeatures = [
    {
      title: 'Studio-Grade Production',
      description: 'Professional 4K video with 32-bit float audio recording in our Bay Area studio. Every episode delivers broadcast quality.',
      icon: '🎥'
    },
    {
      title: 'Engaged Audience',
      description: 'Connect with entrepreneurs, creators, and culture shapers who value authentic content and meaningful conversations.',
      icon: '👥'
    },
    {
      title: 'Brand Integration',
      description: 'Seamless brand integration that feels authentic and adds real value to every conversation.',
      icon: '🤝'
    }
  ];

  return (
    <section id="sponsors" className="sponsors">
      <div className="sponsors-container">
        <div className="sponsors-header">
          <h2 className="sponsors-title">Partner with Point Makers</h2>
          <p className="sponsors-subtitle">
            Our listeners are creators, dreamers, and doers. We collaborate with sponsors who align with that mindset — brands that value authenticity and conversation. Get your message heard on and off the mic.
          </p>
          <div className="sponsors-highlight">
            🏆 Premium Sponsorship Opportunities Available
          </div>
        </div>
        
        <div className="features-grid">
          {sponsorFeatures.map((feature, index) => (
            <div key={index} className="feature-card hover-lift">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
        
        <div className="sponsors-cta">
          <p className="cta-text">
            Ready to reach an engaged audience that values quality content and authentic conversations?
          </p>
          <div className="cta-buttons">
            <a href="mailto:caliraydllc@gmail.com" className="btn-sponsor">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
              </svg>
              Request Sponsorship Info
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sponsors;